export default "__VITE_ASSET__BHlitbyd__"